var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxtf-dialog",
    {
      ref: "dialog",
      class: [_vm.className, _vm.outClass],
      attrs: {
        visible: _vm.currVisible,
        "show-close": _vm.showClose,
        modal: _vm.modal,
        "padding-size": _vm.paddingSize,
        fullscreen: "",
        "before-close": _vm.handleBeforeClose,
        "append-to-body": _vm.appendToBody,
        "custom-class":
          "yxtbiz-o2o-zoom-dialog " +
          _vm.customClass +
          " " +
          (_vm.trident ? "yxtbiz-o2o-zoom-dialog-max" : ""),
        "destroy-on-close": _vm.destroyOnClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.currVisible = $event
        },
        open: _vm.handleOpen,
        closed: _vm.handleClosed,
        opened: _vm.handleOpened,
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "template",
        { slot: "title" },
        [
          _vm.$slots.title
            ? _vm._t("title")
            : _vm.title
            ? _c(
                "div",
                { staticClass: "yxtbiz-o2o-zoom-dialog-title" },
                [
                  _vm.arrowLeft
                    ? _c("o2of-svg", {
                        staticClass: "color-gray-8 hand",
                        attrs: {
                          front: "",
                          width: "24px",
                          height: "24px",
                          name: "left",
                        },
                        nativeOn: {
                          click: function ($event) {
                            return function () {
                              return _vm.closeDialog()
                            }.apply(null, arguments)
                          },
                        },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "yxtbiz-o2o-zoom-dialog-title-innier" },
                    [_vm._v(_vm._s(_vm.title))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c("template", { slot: "default" }, [_vm._t("default")], 2),
      _c("template", { slot: "footer" }, [_vm._t("footer")], 2),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }